import React, { useState } from "react";
import Select from "../../components/Select";

export default function MobileBulkEditBottomSheet({ 
    show, 
    onHide, 
    lookups, 
    onSave,
    selectedCount 
}) {
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);

    const handleCategoryChange = (categoryId) => {
        setSelectedCategoryId(categoryId);
    };

    const handleTagsChange = (tagIds) => {
        setSelectedTags(tagIds);
    };

    const handleSave = () => {
        onSave({
            categoryId: selectedCategoryId,
            tags: selectedTags
        });
        handleClose();
    };

    const handleClose = () => {
        setSelectedCategoryId(null);
        setSelectedTags([]);
        onHide();
    };

    if (!show) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                onClick={handleClose}
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 1000,
                    animation: "fadeIn 0.3s ease-in-out"
                }}
            />
            
            {/* Bottom Sheet */}
            <div
                style={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: "white",
                    borderTopLeftRadius: "20px",
                    borderTopRightRadius: "20px",
                    boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.15)",
                    zIndex: 1001,
                    maxHeight: "80vh",
                    overflowY: "auto",
                    animation: "slideUp 0.3s ease-out",
                    direction: "rtl"
                }}
            >
                {/* Handle bar */}
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "10px 0"
                }}>
                    <div style={{
                        width: "40px",
                        height: "4px",
                        backgroundColor: "#DDD",
                        borderRadius: "2px"
                    }} />
                </div>

                {/* Header */}
                <div style={{
                    padding: "10px 20px 20px",
                    borderBottom: "1px solid #E0E0E0"
                }}>
                    <h3 style={{ 
                        margin: 0, 
                        fontSize: "20px",
                        fontWeight: "bold"
                    }}>
                        עריכה קבוצתית
                    </h3>
                    <p style={{
                        margin: "5px 0 0",
                        color: "#666",
                        fontSize: "14px"
                    }}>
                        {selectedCount} עסקאות נבחרו
                    </p>
                </div>

                {/* Content */}
                <div style={{ padding: "20px" }}>
                    <div style={{ marginBottom: "25px" }}>
                        <h5 style={{ 
                            marginBottom: "10px", 
                            fontWeight: "bold",
                            fontSize: "16px"
                        }}>
                            קטגוריה
                        </h5>
                        <Select
                            options={lookups?.categories || []}
                            selected={selectedCategoryId}
                            onSelect={handleCategoryChange}
                            closeOnSelect={true}
                            placeholder="בחר קטגוריה"
                            isSearchable={true}
                        />
                    </div>

                    <div style={{ marginBottom: "25px" }}>
                        <h5 style={{ 
                            marginBottom: "10px", 
                            fontWeight: "bold",
                            fontSize: "16px"
                        }}>
                            תגיות
                        </h5>
                        <Select
                            options={lookups?.tags || []}
                            selected={selectedTags}
                            onSelect={handleTagsChange}
                            multi={true}
                            placeholder="בחר תגיות"
                            isSearchable={true}
                        />
                    </div>

                    <div style={{ 
                        backgroundColor: "#F8F9FA", 
                        padding: "15px", 
                        borderRadius: "8px",
                        marginBottom: "20px"
                    }}>
                        <p style={{ 
                            margin: 0, 
                            color: "#6C757D", 
                            fontSize: "13px",
                            lineHeight: "1.5"
                        }}>
                            השינויים יחולו על כל העסקאות שנבחרו. 
                            אם לא תבחר קטגוריה או תגיות, הם לא ישתנו.
                        </p>
                    </div>
                </div>

                {/* Action Buttons */}
                <div style={{
                    padding: "15px 20px 25px",
                    display: "flex",
                    gap: "10px",
                    borderTop: "1px solid #E0E0E0"
                }}>
                    <button
                        onClick={handleClose}
                        style={{
                            flex: 1,
                            padding: "12px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            border: "2px solid #6C757D",
                            backgroundColor: "white",
                            color: "#6C757D",
                            borderRadius: "8px",
                            cursor: "pointer"
                        }}
                    >
                        ביטול
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={!selectedCategoryId && selectedTags.length === 0}
                        style={{
                            flex: 1,
                            padding: "12px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            border: "none",
                            backgroundColor: (!selectedCategoryId && selectedTags.length === 0) 
                                ? "#CCC" 
                                : "#007BFF",
                            color: "white",
                            borderRadius: "8px",
                            cursor: (!selectedCategoryId && selectedTags.length === 0) 
                                ? "not-allowed" 
                                : "pointer"
                        }}
                    >
                        שמור שינויים
                    </button>
                </div>
            </div>

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                
                @keyframes slideUp {
                    from { transform: translateY(100%); }
                    to { transform: translateY(0); }
                }
            `}</style>
        </>
    );
}